/**
 * Check if current browser is Safari.
 */
export function isSafari() {
    const ua = navigator.userAgent;
    return ua.indexOf('Safari/') > -1 && ua.indexOf('Chrome/') <= -1;
}
